import { Mail, Building2 } from "lucide-react";
import { PROJECTS, IDENTITY } from "@/data/content";
import { SmartImg, Tag } from "@/components/primitives";

export default function ProjectWindow({ projectId }) {
    const project = PROJECTS.find((p) => p.id === projectId);
    if (!project) return <div className="p-8 font-mono text-sm text-neutral-500">plate not found.</div>;

    return (
        <div data-testid="project-window" className="p-6 sm:p-8">
            <div className="flex flex-wrap items-center gap-2.5 mb-4">
                <span className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1 rounded bg-vermilion text-white">
                    {project.category}
                </span>
                <span className="inline-flex items-center gap-1.5 font-mono text-[11px] text-neutral-500">
                    <Building2 size={11} /> {project.client}
                </span>
            </div>
            <h2 className="text-2xl font-bold tracking-tight leading-tight" data-testid="project-window-title">
                {project.title}
            </h2>
            <div className="group mt-5 rounded-md overflow-hidden border border-black/15 bg-black/[0.03]">
                <SmartImg
                    src={project.image}
                    fallback={project.fallback}
                    alt={project.title}
                    className="w-full max-h-72 object-contain halftone"
                />
            </div>
            <p className="mt-5 text-sm text-neutral-600 leading-relaxed">{project.description}</p>
            <div className="mt-6 border-t border-black/10 pt-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-3">
                    $ dpkg -l · installed stack
                </p>
                <div className="flex flex-wrap gap-1">
                    {project.tags.map((t) => (
                        <Tag key={t}>{t}</Tag>
                    ))}
                </div>
            </div>
            <a
                href={`mailto:${IDENTITY.email}?subject=Project inquiry: ${encodeURIComponent(project.title)}`}
                data-testid="project-window-contact"
                className="mt-7 inline-flex items-center gap-2 rounded-md bg-[#1a1a1a] text-white px-5 py-2.5 text-xs font-semibold tracking-wide hover:bg-vermilion transition-colors duration-200"
            >
                <Mail size={13} /> Discuss a build like this
            </a>
        </div>
    );
}
